import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const MessagesIcon = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [count, setCount] = useState(0);
  const prev = useRef(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/messages/unread-count").then(({ data }) => {
      if (!alive) return;
      const n = data.count || 0;
      if (prev.current !== null && n > prev.current && !location.pathname.startsWith("/messages")) {
        toast.message("New message", { description: "You have a new message on Pula", action: { label: "Open", onClick: () => navigate("/messages") } });
      }
      prev.current = n;
      setCount(n);
    }).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    return () => { alive = false; clearInterval(t); };
  }, [location.pathname, navigate]);
  return (
    <button data-testid="nav-messages-icon" onClick={() => navigate("/messages")} title="Messages"
      className="relative flex items-center justify-center w-9 h-9 rounded-full text-pula-ink hover:bg-pula-bg2 transition-colors">
      <MessageCircle className="w-5 h-5" />
      {count > 0 && <span data-testid="messages-unread-badge" className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-pula-accent text-white text-[10px] grid place-items-center">{count > 9 ? "9+" : count}</span>}
    </button>
  );
};
